<template>
    <div class="chat-window-manager-tool">
        <Tooltip :title="`${$t('chat.layouts.chat')} (Ctrl + 1)`" color="#22272d">
            <div
                class="chat-window-manager-tool-item"
                :class="{ active: activeView === 'chat' }"
                @click="setActiveView('chat')"
            >
                <div class="material-icons">auto_awesome_mosaic</div>
            </div>
        </Tooltip>
        <Tooltip :title="`${$t('chat.layouts.table')} (Ctrl + 2)`" color="#22272d">
            <div
                class="chat-window-manager-tool-item"
                :class="{ active: activeView === 'list' }"
                @click="setActiveView('list')"
            >
                <div class="material-icons">list_alt</div>
            </div>
        </Tooltip>
        <Tooltip :title="`${$t('chat.layouts.kanban')} (Ctrl + 3)`" color="#22272d">
            <div
                class="chat-window-manager-tool-item"
                :class="{ active: activeView === 'kanban' }"
                @click="setActiveView('kanban')"
            >
                <div class="material-icons">view_kanban</div>
            </div>
        </Tooltip>
    </div>
</template>
<script>
import { Tooltip } from "ant-design-vue";
import { mapActions, mapState } from "vuex";

export default {
    name: "ChatWindowManagerTool",
    components: { Tooltip },
    computed: {
        ...mapState({
            activeView: (state) => state.contact.activeView,
        }),
    },
    methods: {
        ...mapActions({
            setActiveView: "contact/setActiveView",
        }),
    },
};
</script>
<style lang="scss">
.chat-window-manager-tool {
    position: absolute;
    width: max-content;
    bottom: 0;
    left: 0;
    margin: 20px;
    background: #fff;
    border: 1px solid var(--color-border-default);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    overflow: hidden;
    user-select: none;
    z-index: 8;
    transform: translateZ(0);
    pointer-events: auto;

    &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        cursor: pointer;

        &.active {
            background: #22272d;
            color: #fff;
        }

        &:hover {
            background: #f0f0f0;
            color: #22272d;
        }
    }
}
</style>
